import Constants from 'Constants'
import { EventBus } from 'EventBus'
import Common from '@/assets/js/common.js'

const PaxMixin = {
    methods: {
        getCriteres: async function(lang = null) {
            let url = Constants.PAX_CRITERES + "?licence_key="+Constants.USER_LICENCE_KEY
            if(lang !== null) {
            	url += "&lang=" + lang
            }

			const result = await this.$request.request_get_api("PaxMixin::getCriteres", url)
			.catch(error => {
				console.error("PaxMixin::getCriteres => ERROR", error)
				return null
			})

			return result ? result.retour : null
        },

		saveCaracterisationByHorse: async function(horse_id, criteres_id, criteres_value, caracterisation_certified) {
            const url =  this.constructRoute(Constants.PAX_CARACTERISATION_HORSE, { horse_id }) +'?licence_key='+Constants.USER_LICENCE_KEY
            const params = {criteres: [{criteres_id, criteres_value}], caracterisation_certified}

            const response = await this.$request.request_post_api("PaxMixin::saveCaracterisationByHorse", url, params, false)
            .catch(e => {
                return false
            })

            if(response.code_retour === 0){
                return true
            }
		},

		getCaracterisationByHorse: async function(horse_id, tiers_id = null) {
            let url =  this.constructRoute(Constants.PAX_CARACTERISATION_HORSE, { horse_id }) +'?licence_key='+Constants.USER_LICENCE_KEY
            if(tiers_id !== null) {
            	url += "&tiers_id=" + tiers_id
            }


			const result = await this.$request.request_get_api("PaxMixin::getCaracterisationByHorse", url)
			.catch(error => {
				console.error("PaxMixin::getCaracterisationByHorse => ERROR", error)
				return null
			})

			return result ? result.retour : null
		},

		getTiersCaracterisationByHorse: async function (horse_id) {
            let url =  this.constructRoute(Constants.PAX_CARACTERISATION_HORSE_TIERS, { horse_id }) +'?licence_key='+Constants.USER_LICENCE_KEY

			const result = await this.$request.request_get_api("PaxMixin::getTiersCaracterisationByHorse", url)
			.catch(error => {
				console.error("PaxMixin::getTiersCaracterisationByHorse => ERROR", error)
				return null
			})

			return result ? result.retour : null
		},

		saveCertifiedByHorse: async function(horse_id, certified) {
            let url =  this.constructRoute(Constants.PAX_CARACTERISATION_HORSE_CERTIFIED, { horse_id }) +'?licence_key='+Constants.USER_LICENCE_KEY

			const result = await this.$request.request_post_api("PaxMixin::saveCertifiedByHorse", url, {certified}, false)
			.catch(error => {
				console.error("PaxMixin::saveCertifiedByHorse => ERROR", error)
				return null
			})

			return result ? result.retour : null
		},

		saveStallionCountries: async function(horse_id, countries) {
            const url =  this.constructRoute(Constants.PAX_PAYS_DISPO_HORSE, { horse_id }) +'?licence_key='+Constants.USER_LICENCE_KEY

            const response = await this.$request.request_post_api("PaxMixin::saveStallionCountries", url, {countries}, false)
            .catch(e => {
                return false
            })

            if(response.code_retour === 0){
                return true
            }
		},

		getStallionCountries: async function(horse_id) {
            const url =  this.constructRoute(Constants.PAX_PAYS_DISPO_HORSE, { horse_id }) +'?licence_key='+Constants.USER_LICENCE_KEY

			const result = await this.$request.request_get_api("PaxMixin::getStallionCountries", url)
			.catch(error => {
				console.error("PaxMixin::getStallionCountries => ERROR", error)
				return null
			})

			return result ? result.retour : null
		},

		saveCritereByLang: async function(criteres_id, lang, params) {
            const url =  this.constructRoute(Constants.PAX_CRITERES_BY_ID, { criteres_id }) +'?licence_key='+Constants.USER_LICENCE_KEY + "&lang=" + lang

            const response = await this.$request.request_post_api("PaxMixin::saveCritereByLang", url, params, false)
            .catch(e => {
                return false
            })

            if(response.code_retour === 0){
                return true
            }
		},

		getStallionCompatibilite: async function(horse_id, age, cp, grade, indicator, general) {
            let url = this.constructRoute(Constants.PAX_COMPATIBILITE_STALLION, { horse_id }) +'?licence_key='+Constants.USER_LICENCE_KEY
            if(age) {
            	url += "&age="+age
            }
            if(cp) {
            	url += "&cp="+cp
            }
            if(grade) {
            	url += "&grade="+grade
            }
            if(indicator) {
            	url += "&indicator="+indicator
            }
            if(general) {
            	url += "&general="+general
            }

			const result = await this.$request.request_get_api("PaxMixin::getStallionCompatibilite", url)
			.catch(error => {
				console.error("PaxMixin::getStallionCompatibilite => ERROR", error)
				return null
			})

			return result ? result.retour : null
		},

		getMareCompatibilite: async function(horse_id, grade, indicator, general) {
            let url = this.constructRoute(Constants.PAX_COMPATIBILITE_MARE, { horse_id }) +'?licence_key='+Constants.USER_LICENCE_KEY
            if(grade) {
            	url += "&grade="+grade
            }
            if(indicator) {
            	url += "&indicator="+indicator
            }
            if(general) {
            	url += "&general="+general
            }

			const result = await this.$request.request_get_api("PaxMixin::getMareCompatibilite", url)
			.catch(error => {
				console.error("PaxMixin::getMareCompatibilite => ERROR", error)
				return null
			})

			return result ? result.retour : null
		},

	    printSimulationCroisement: async function(mare_id, stallion_id) {
			const url = this.constructRoute(Constants.PAX_SIMULATION_PRINT, {mare_id,stallion_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			const result = await this.$request.request_get_api("PaxMixin::printSimulationCroisement", url)
			if(result) {
				Common.base64ToPdf(result, 'croisement.pdf')
				EventBus.$emit('TableAction::stopSpin')
				return true
			}
			return null
	    }
    }
}

export default PaxMixin